import React, { useEffect } from "react";
import Error from "../../../components/layout/Error/index.js";


function ErrorPage() {
  // Remove nav-open class from document element
  document.documentElement.classList.remove("nav-open");

  // Add profile-page class to body on mount and remove on unmount
  useEffect(() => {
    document.body.classList.add("profile-page");
    
    return () => {
      document.body.classList.remove("profile-page");
    };
  }, []); // Empty dependency array ensures this runs only on mount/unmount

  return (
    <>
      <Error />
    </>
  );
}

export default ErrorPage;
